export default "__VITE_ASSET__kYYS40Ww__"